import React, { useRef } from 'react'
import './oto3.css'
import oto3 from '../image/oto-3.png'
import guaranteeOto3 from '../image/guarantee-oto3.jpg'
import oto3video from '../image/oto3-video.mp4'
import oto3addtocart from '../image/oto3-addtocart.png'
/** Active step for this page: 3 = on “Activate” (see https://leadszora.com/oto3/ ) */
const CURRENT_STEP = 3

function CheckIcon() {
  return (
    <svg
      className="oto3-circle__check"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20 6L9 17l-5-5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function StepStatus({ stepId, current }) {
  if (stepId < current) {
    return (
      <span className="oto3-status oto3-status--complete">✓ Completed</span>
    )
  }
  if (stepId === current) {
    return (
      <span className="oto3-status oto3-status--current-pending">
        <span className="oto3-status__lead" aria-hidden>
          ○
        </span>
        Pending
      </span>
    )
  }
  return (
    <span className="oto3-status oto3-status--current-pending">
      <span className="oto3-status__lead" aria-hidden>
        ○
      </span>
      Pending
    </span>
  )
}

const STEP_LABELS = [
  { id: 1, lines: ['Step 1: Complete'] },
  { id: 2, lines: ['Step 2: Customize Order'] },
  { id: 3, lines: ['Step 3: Activate'] },
]

const OTO3_UNLIMITED_ACCESS = [
  'Unlimited lead searches (no caps)',
  'Unlimited lists, tags & saved leads',
  'Unlimited outreach messages & follow-ups',
  'Unlimited exports (CSV / CRM ready)',
  'Unlimited AI message generation',
  'No daily / monthly limits — full freedom',

]

const OTO3_WHO_CHOOSE = [
  'Agencies managing multiple clients',
  'Teams running daily outreach campaigns',
  'Freelancers scaling their business',
  'B2B service providers & consultants',
  'Anyone serious about long-term growth',

]

const OTO3_WHY_POWER = [
  'Scale campaigns without restrictions',
  'Manage multiple pipelines & clients',
  'Automate outreach & follow-ups',
  'Track full lead lifecycle (New → Closed)',
  'Build a real lead generation system (not just a tool)',

]

const OTO3_PACKAGE_BENEFITS = [
  {
    key: 'caps',
    title: 'No Limits',
    text: 'Generate & manage unlimited leads',
    icon: 'infinity',
  },
  {
    key: '247',
    title: 'Always-On Access',
    text: 'Use anytime, anywhere',
    icon: 'globe',
  },
  {
    key: 'scale',
    title: 'Scale Faster',
    text: 'No restrictions holding you back',
    icon: 'rocket',
  },
  {
    key: 'support',
    title: 'Priority Support',
    text: 'Faster help for serious users',
    icon: 'support',
  },
  {
    key: 'support',
    title: 'Team Collaboration',
    text: 'Share leads & manage together',
    icon: 'globe',
  },
]

function ListCheckIcon() {
  return (
    <svg
      className="oto3-unlock__check"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20 6L9 17l-5-5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function LightningIcon() {
  return (
    <svg
      className="oto3-unlock-card__bolt"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z" />
    </svg>
  )
}

function LightningBulletIcon() {
  return (
    <svg
      className="oto3-unlock__bolt-sm"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z" />
    </svg>
  )
}

function DiamondIcon() {
  return (
    <svg
      className="oto3-unlock-card__diamond"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2l8 10-8 10-8-10 8-10z" />
    </svg>
  )
}

function BenefitIcon({ name }) {
  const mod =
    name === 'infinity'
      ? 'purple'
      : name === 'globe'
        ? 'blue'
        : name === 'rocket'
          ? 'gold'
          : 'teal'
  return (
    <span
      className={`oto3-unlock-benefit__ico oto3-unlock-benefit__ico--${mod}`}
      aria-hidden
    >
      {name === 'infinity' ? (
        <span className="oto3-unlock-benefit__sym">∞</span>
      ) : null}
      {name === 'globe' ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
        </svg>
      ) : null}
      {name === 'rocket' ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 19l-4.5-4.5c-.83-.83-1-2.09-.45-3.09L9 5c.35-.77 1.1-1.25 1.95-1.25h2.1c.85 0 1.6.48 1.95 1.25l5 6.36c.55 1 .38 2.26-.45 3.09L15 19h-2v-3h-2v3H9zm2.5-10.5c.83 0 1.5-.67 1.5-1.5S14.33 5 13.5 5 12 5.67 12 6.5s.67 1.5 1.5 1.5zM5 20l1.5-4.5L9 20H5z" />
        </svg>
      ) : null}
      {name === 'support' ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        </svg>
      ) : null}
    </span>
  )
}

export default function Oto3() {
  const unlockCartRef = useRef(null)

  const scrollToUnlockCart = () => {
    unlockCartRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <>
      <section className="oto3-stepper-section" aria-label="OTO3 setup progress">
        <div className="oto3-stepper-inner">
          <div
            className="oto3-stepper"
            data-current-step={String(CURRENT_STEP)}
          >
            <div className="oto3-circles-row" role="list">
              {STEP_LABELS.map((step) => {
                const isComplete = step.id < CURRENT_STEP
                const isCurrent = step.id === CURRENT_STEP

                let circleClass = 'oto3-circle'
                if (isComplete) circleClass += ' oto3-circle--complete'
                else if (isCurrent) circleClass += ' oto3-circle--current'
                else circleClass += ' oto3-circle--pending'

                return (
                  <div key={step.id} className="oto3-circle-col" role="listitem">
                    <div
                      className={circleClass}
                      aria-current={isCurrent ? 'step' : undefined}
                    >
                      {isComplete ? (
                        <CheckIcon />
                      ) : (
                        <>
                          {step.id}
                          {isCurrent && step.id === 3 ? (
                            <span className="oto3-circle__badge" aria-hidden />
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="oto3-labels-row">
              {STEP_LABELS.map((step) => {
                const isComplete = step.id < CURRENT_STEP
                const isCurrent = step.id === CURRENT_STEP
                let boxClass = 'oto3-label-box'
                if (isComplete) boxClass += ' oto3-label-box--complete'
                else if (isCurrent) boxClass += ' oto3-label-box--current'
                else boxClass += ' oto3-label-box--pending'

                return (
                  <div key={step.id} className="oto3-label-col">
                    <div className={boxClass}>
                      {step.lines.map((line, i) => (
                        <React.Fragment key={line}>
                          {i > 0 ? <br /> : null}
                          {line}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="oto3-status-row">
              {STEP_LABELS.map((step) => (
                <div key={step.id} className="oto3-status-col">
                  <StepStatus stepId={step.id} current={CURRENT_STEP} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        className="oto3-offer"
        aria-labelledby="oto3-offer-heading"
      >
        <div className="oto3-offer__inner">
          <h2 id="oto3-offer-heading" className="oto3-offer__title">
            Unlock Unlimited Growth — {' '}
            <span className="oto3-offer__accent">
              Remove All Limits & Scale Like An Agency

            </span>
          </h2>
          <p className="oto3-offer__sub">
            Get unlimited access to leads, outreach, AI messaging, team features & workflow automation — without any restrictions

          </p>

          <div className="oto3-offer-media">
            
          
              {/* <img
                className="oto3-offer-media__poster"
                src={oto3}
                alt="OTO 3"
                width={1200}
                height={675}
              /> */}
           <video
                  className="jv-video-frame__player"
                  controls
                  playsInline
                  preload="metadata"
                  poster={oto3}
                  src={oto3video}
                  title="Demo: high-converting funnel and system"
                >
                  Your browser does not support the video tag.
                </video>   
          </div>

          <button type="button" className="oto3-offer-cta" onClick={scrollToUnlockCart}>
            <span className="oto3-offer-cta__primary">
              Click Here To Add This To Your Order! »
            </span>
            <span className="oto3-offer-cta__secondary">
              Yes, Add Advanced Research Suite To My Order
            </span>
          </button>

          <div className="oto3-offer-pricing">
            <div className="oto3-offer-pricing__head">
              <p className="oto3-offer-pricing__label">One-Time Upgrade</p>
              <p className="oto3-offer-pricing__price">$98</p>
            </div>
            <ul className="oto3-offer-pricing__list">
              <li>Unlimited Leads + Team Access</li>
              <li>Full System Power</li>
            </ul>
            <div className="oto3-offer-pricing__meta">
              <span className="oto3-offer-pricing__tag">No Subscription</span>
              <span className="oto3-offer-pricing__tag">No Hidden Fees</span>
            </div>
            <p className="oto3-offer-pricing__note">Instant access after checkout</p>
          </div>

          <p className="oto3-offer__foot-tag">ONE-TIME PAYMENT.</p>
          <p className="oto3-offer__foot-note">
            Get lifetime access with no caps on usage — scale as much as you want without hitting limits.
          </p>
        </div>
      </section>

      <section
        className="oto3-unlock"
        aria-labelledby="oto3-unlock-heading"
      >
        <div className="oto3-unlock__inner">
          <h2 id="oto3-unlock-heading" className="oto3-unlock__title">
            Go Unlimited — {' '}
            <span className="oto3-unlock__yellow">Run Your Entire Lead Gen & Outreach System Without Limits
            </span>
          </h2>
          <p className="oto3-unlock__lead">
            Go Unlimited — built for serious scale & power users
          </p>

          <div className="oto3-unlock-hero">
            <div className="oto3-unlock-hero__inner">
              <div className="oto3-unlock-hero__head">
                <div className="oto3-unlock-hero__head-left">
                  <div className="oto3-unlock-hero__icon-square" aria-hidden>
                    <span className="oto3-unlock-hero__infinity">∞</span>
                  </div>
                  <div>
                    <p className="oto3-unlock-hero__kicker">
                      Unlimited Lead Generation + Full Workflow Control
                    </p>
                    <p className="oto3-unlock-hero__sub">
                      No limits on lead generation - scale without restrictions
                    </p>
                  </div>
                </div>
                <div className="oto3-unlock-hero__pills">
                  <span className="oto3-unlock-hero__pill oto3-unlock-hero__pill--purple">
                    ∞ Unlimited
                  </span>
                  <span className="oto3-unlock-hero__pill oto3-unlock-hero__pill--blue">
                    <span aria-hidden>🚀</span> Scale Freely
                  </span>
                  <span className="oto3-unlock-hero__pill oto3-unlock-hero__pill--dark">
                    <span aria-hidden>⚙️</span> No Caps
                  </span>
                </div>
              </div>
              <div className="oto3-unlock-hero__stats">
                <div className="oto3-unlock-hero__stat">

                  <span className="oto3-unlock-hero__stat-label">
                    Unlimited Leads

                  </span>
                </div>
                <div className="oto3-unlock-hero__stat">
                  <span className="oto3-unlock-hero__stat-label">
                    Unlimited Outreach & AI Messages

                  </span>
                </div>
                <div className="oto3-unlock-hero__stat">
                  <span className="oto3-unlock-hero__stat-label">
                    Team Access + Shared Data

                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="oto3-unlock-columns">
            <article className="oto3-unlock-card oto3-unlock-card--yellow">
              <h3 className="oto3-unlock-card__title">
                <LightningIcon />
                Unlimited Access
              </h3>
              <ul className="oto3-unlock-list">
                {OTO3_UNLIMITED_ACCESS.map((t) => (
                  <li key={t}>
                    <LightningBulletIcon />
                    {t}
                  </li>
                ))}
              </ul>
            </article>
            <article className="oto3-unlock-card oto3-unlock-card--blue">
              <h3 className="oto3-unlock-card__title">
                <DiamondIcon />
                Who Should Choose This?
              </h3>
              <ul className="oto3-unlock-list">
                {OTO3_WHO_CHOOSE.map((t) => (
                  <li key={t}>
                    <ListCheckIcon />
                    {t}
                  </li>
                ))}
              </ul>
            </article>
            <article className="oto3-unlock-card oto3-unlock-card--blue">
              <h3 className="oto3-unlock-card__title">
                <DiamondIcon />
                Why Power Users Choose This
              </h3>
              <ul className="oto3-unlock-list">
                {OTO3_WHY_POWER.map((t) => (
                  <li key={t}>
                    <ListCheckIcon />
                    {t}
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="oto3-unlock-benefits-wrap">
            <h3 className="oto3-unlock-benefits-title">
              <span className="oto3-unlock-benefits-title__sym" aria-hidden>
                ∞
              </span>{' '}
              Unlimited Leads Package Benefits
            </h3>
            <div className="oto3-unlock-benefits-grid">
              {OTO3_PACKAGE_BENEFITS.map((b) => (
                <article key={b.key} className="oto3-unlock-benefit">
                  <BenefitIcon name={b.icon} />
                  <h4 className="oto3-unlock-benefit__title">{b.title}</h4>
                  <p className="oto3-unlock-benefit__text">{b.text}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="oto3-unlock-cart" ref={unlockCartRef}>
          <div className="oto3-get-cta__cart-btn">
              <a
                className="oto3-get-cta__cart-btn-img"
                href="https://warriorplus.com/o2/buy/sd90jm/mv3rc4/tjzkpl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={oto3addtocart} alt="Add to Cart" />
              </a>
            </div>
            </div>
            <p className="oto2-pricing-pro__disclaimer">
              <em>WarriorPlus is used to help manage the sale of products on this site. While WarriorPlus helps facilitate the sale, all payments are made directly to the product vendor and NOT WarriorPlus. Thus, all product questions, support inquiries and/or refund requests must be sent to the vendor. WarriorPlus's role should not be construed as an endorsement, approval or review of these products or any claim, statement or opinion used in the marketing of these products.</em>
            </p>
            <p className="oto3-unlock-cart__foot">
              <span className="oto3-unlock__yellow">
                Unlimited Leads + Outreach + Team Access

              </span>
            </p>
            <p className="oto3-unlock-cart__instant">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
              </svg>
              Instant Access • Complete Contact Data
            </p>
        </div>
      </section>

      <section
        className="oto3-urgent"
        aria-labelledby="oto3-urgent-headline"
      >
        <div className="oto3-urgent__inner">
          <p className="oto3-urgent__updated">Updated 3 minutes ago</p>

          <div
            className="oto3-urgent__track"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={80}
            aria-label="Offer availability"
          >
            <div className="oto3-urgent__fill">
              <span className="oto3-urgent__fill-text">
                This Is Your Only Chance To Unlock Unlimited Access
              </span>
            </div>
          </div>

          <div className="oto3-urgent__headline-box" id="oto3-urgent-headline">
          Don’t Let Limits Slow Down Your Growth & Scaling

          </div>

          <p className="oto3-urgent__intro">
            This is an optional upgrade available during checkout.
          </p>

          <p className="oto3-urgent__bold-line">
            One-time upgrade available during checkout. No recurring subscription
            required.
          </p>

          <p className="oto3-urgent__fine">
          Right now you have limits… with this upgrade, you remove all restrictions and unlock full system power to scale faster

          </p>
          <p className="oto3-urgent__fine oto3-urgent__fine--small">
            This Offer Could Be Removed At Any Time, So Please Click The Button To
            Join Us Now!
          </p>

          <a className="oto3-urgent__cta" onClick={scrollToUnlockCart}>
            <span className="oto3-urgent__cta-row">
              {/* <svg
              className="oto3-urgent__cta-cart"
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.15.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg> */}
              <span className="oto3-urgent__cta-main">
                Yes! Unlock Unlimited Agency Access

              </span>
            </span>
            <span className="oto3-urgent__cta-sub">
              Yes – I Want To Generate MORE SALES {'&'} COMMISSIONS Daily!
            </span>
          </a>

        </div>
      </section>

      <section
        className="oto3-guarantee-block"
        aria-labelledby="oto3-guarantee-heading"
      >
        <div className="oto3-guarantee-block__inner">
          <p className="oto3-guarantee-block__badge">
            <svg
              className="oto3-guarantee-block__badge-shield"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
            </svg>
            100% RISK-FREE GUARANTEE
          </p>
          <h2 id="oto3-guarantee-heading" className="oto3-guarantee-block__title">
            7-Day Money-Back Guarantee
          </h2>
          <p className="oto3-guarantee-block__lead">
            This upgrade is covered by our 7-day money-back guarantee.
          </p>

          <div className="oto3-guarantee-block__grid">
            <div className="oto3-guarantee-block__media">
              <img
                className="oto3-guarantee-block__img"
                src={guaranteeOto3}
                alt="Leadszora dashboard preview"
              />
            </div>
            <div className="oto3-guarantee-block__cards">
              <article className="oto3-guarantee-card">
                <div className="oto3-guarantee-card__head">
                  <span className="oto3-guarantee-card__icon" aria-hidden>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.16-1.62-4.16-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.73 1.36 4.73 4.08c-.01 1.77-1.29 2.99-3.01 3.28z" />
                    </svg>
                  </span>
                  <h3 className="oto3-guarantee-card__title">
                    Full Refund Within 7 Days
                  </h3>
                </div>
                <p className="oto3-guarantee-card__text">
                  If Unlimited Agency Access isn&apos;t the right fit for you, you
                  may request a refund within 7 days of purchase, in accordance
                  with our refund policy.
                </p>
              </article>
              <article className="oto3-guarantee-card oto3-guarantee-card--important">
                <div className="oto3-guarantee-card__head">
                  <span
                    className="oto3-guarantee-card__icon oto3-guarantee-card__icon--warn"
                    aria-hidden
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                  </span>
                  <h3 className="oto3-guarantee-card__title">Important Note</h3>
                </div>
                <p className="oto3-guarantee-card__text">
                  Refund requests must be submitted through the appropriate support
                  channel and are subject to standard review.
                </p>
              </article>
              <article className="oto3-guarantee-card oto3-guarantee-card--support">
                <div className="oto3-guarantee-card__head">
                  <span
                    className="oto3-guarantee-card__icon oto3-guarantee-card__icon--mail"
                    aria-hidden
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                  </span>
                  <h3 className="oto3-guarantee-card__title">
                    Need Help or Have Questions?
                  </h3>
                </div>
                <div className="oto3-guarantee-card__support-row">
                  <p className="oto3-guarantee-card__text oto3-guarantee-card__text--support">
                    Our support team is here to assist you.
                  </p>
                  <a
                    className="oto3-guarantee-card__btn"
                    href="mailto:support@leadszora.com"
                  >
                    <svg
                      className="oto3-guarantee-card__btn-ico"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                    Contact Support
                  </a>
                </div>
                <p className="oto3-guarantee-card__email">
                  Email us at:{' '}
                  <a href="mailto:support@leadszora.com">support@leadszora.com</a>
                </p>
              </article>
            </div>
          </div>

          {/* <div className="oto3-guarantee-block__disclaimer">
            <p>
              <strong>Disclaimer:</strong>{' '}
              WarriorPlus is used to help manage the sale of products on this
              site. While WarriorPlus facilitates the transaction, product
              delivery, billing, and support are handled by the vendor (Leadszora).
              For refunds or product questions, contact the vendor through the
              support channels on your receipt or this page.
            </p>
          </div> */}
          <div className="oto3-guarantee-block__try">
            <p>
            Try unlimited features risk-free for 7 days

            </p>
          </div>
        </div>
      </section>

      <footer className="oto3-site-footer">
        <div className="oto3-site-footer__inner">
          <p className="oto3-site-footer__copy">
            © {new Date().getFullYear()} Leadszora. All Rights Reserved.
          </p>
          <nav className="oto3-site-footer__nav" aria-label="Footer">
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span className="oto3-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span className="oto3-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span className="oto3-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>
    </>
  )
}
